export default __webpack_public_path__ + "static/media/next-arrow.3d1ca6fa.svg";